import { Component, Input } from '@angular/core';

import { trackByValue } from '@recruitee/common';
import { TranslatePipe } from '@recruitee/i18n';
import { RtTooltip, IconComponent, IconColorDirective } from '@recruitee/user-interface';

import { MissingFeature } from '../product-order-downgrade.types';

@Component({
  selector: 'rt-multilink-downgrade-item',
  templateUrl: './multilink-downgrade-item.component.html',
  styleUrls: ['./multilink-downgrade-item.component.less'],
  standalone: true,
  imports: [IconColorDirective, IconComponent, RtTooltip, TranslatePipe],
})
export class MultilinkDowngradeItemComponent {
  @Input() public missingFeature: MissingFeature;
  @Input() public trial: boolean;

  public trackByValue = trackByValue;
}
